import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('user', ['userInfo']),
	...mapState('user', ['teacherInfo'])
  },
  methods: {
    // 也可以将更新用户信息的 action 混入
    updateUserInfo(newInfo) {
      this.$store.dispatch('user/updateUserInfo', newInfo);
    },
	updateTeacherInfo(newInfo) {
	  this.$store.dispatch('user/updateTeacherInfo', newInfo);
	}
  }
};